import useHealthCenterRules from "./useHealthCenterRules";

const usePatientPhoneRequired = () =>
  !!useHealthCenterRules("patients").contact?.phone?.required;

export default usePatientPhoneRequired;
